import type { AuthState } from "./types";

export const initialState: AuthState = {
  isLoading: true,
  user: null,
  organizationId: null,
};

/**
 * localStorage key holding the mock/demo WorkOS session. Written by the
 * authkit redirect callback, by the mock login entry, and by the Playwright
 * fixtures; read by `WorkosPrivateRoutes` to hydrate `workosAuthAtom`.
 */
export const DEMO_AUTH_STORAGE_KEY = "MEQ-demo-auth-state";
